// src/theme/DashboardTheme.jsx
// Tema dark/light SCOPEADO al dashboard logueado.
//
// - Default: dark (si no hay preferencia guardada).
// - Persiste la elección del usuario en localStorage ('ee-dash-theme').
// - Aplica data-theme="dark|light" en <html> SOLO mientras el dashboard
//   está montado. Al desmontar (salir a landing/login/checkout) limpia el
//   attribute para que esas páginas — diseñadas en light — no se vean
//   afectadas. Las vars dark viven en index.css bajo [data-theme="dark"].
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'ee-dash-theme';

const ThemeCtx = createContext({ theme: 'dark', toggleTheme: () => {}, setTheme: () => {} });

function readInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch (_) { /* localStorage no disponible */ }
  return 'dark'; // por defecto, dark
}

export function DashboardThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitialTheme);

  // Aplica el theme al <html> cada vez que cambia.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // Al desmontar el dashboard, limpia el attribute → la app vuelve a las
  // vars light de :root (landing / auth / checkout intactas).
  useEffect(() => {
    return () => { document.documentElement.removeAttribute('data-theme'); };
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme((t) => {
      const next = t === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(STORAGE_KEY, next); } catch (_) { /* noop */ }
      return next;
    });
  }, []);

  return (
    <ThemeCtx.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useDashboardTheme() {
  return useContext(ThemeCtx);
}
